import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { formatDateTime } from '@/lib/utils';
import { useSubscriptionWarning } from '@/hooks/useSubscriptionWarning';
import { getSubscriptionWarningCopy } from '@/lib/subscriptionWarningCopy';
import { useOrgStore } from '@/stores/orgStore';
import { WorklynxIcon } from '@/components/icons/WorklynxIcon';

export function TrialLifecycleBanner() {
  const organization = useOrgStore((state) => state.organization);
  const memberRole = useOrgStore((state) => state.memberRole);
  const warningQuery = useSubscriptionWarning();

  // An employee cannot renew a subscription, and their employer's billing is not
  // something the platform should announce to them.
  if (!organization || (memberRole !== 'BO' && memberRole !== 'BM')) return null;

  const warning = warningQuery.data;
  if (!warning || warning.level === 'NONE') return null;

  const copy = getSubscriptionWarningCopy(warning);
  if (!copy) return null;

  return (
    <div className="border-b border-warning/30 bg-warning-soft/45 px-4 py-3 sm:px-6 lg:px-8 xl:px-10">
      <div className="mx-auto flex max-w-[1600px] flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 items-start gap-3">
          <WorklynxIcon name="warning" size={20} className="mt-0.5 shrink-0 text-warning" />
          <div className="min-w-0">
            <p className="text-sm font-semibold text-foreground">{copy.title}</p>
            <p className="text-xs text-muted">
              {copy.body}
              {warning.deadline ? ` Due ${formatDateTime(new Date(warning.deadline))}.` : ''}
            </p>
          </div>
        </div>
        {memberRole === 'BO' && (
          <Button asChild size="sm" className="shrink-0">
            <Link to="/bo/billing">
              <WorklynxIcon name="billing" size={16} />
              {copy.actionLabel}
            </Link>
          </Button>
        )}
      </div>
    </div>
  );
}
